import store from '@/store/app';

export default function registerHasAccessRights(app) {
  app.config.globalProperties.hasAccessRights = (accessRights) =>
    store.getters['auth/hasAccessRights'](accessRights);
}
